
import { AssetType } from '@shared/models/entities/asset/assetType';
import { Mime } from '@shared/models/entities/asset/mimeType';
import { SaveStoryAssetDto } from './saveStoryAsset.dto';

export class SaveImageAssetDto extends SaveStoryAssetDto {
    constructor(public base64: string, mimeType: Mime, assetType: AssetType,
        name: string,
        storyId: number) {
        super(mimeType, assetType, name, storyId);
    }
}